const works = [
  {
    slug: "svalbard",
    name: "Svalbard",
    desc: "Exercise layout for a fictional website. Svalbard the northern most town on earth and home for the global seed vault.",
    link: "",
    thumb:"/img/svalbard/thumb.png",
    mainImg: "/img/svalbard/landing.png",
    roleTags: "UI | UX DESIGN",
    role: "UI and UX Design of the landing page using sketch.",
    imgs:[
      "/img/svalbard/homepage.png",
    ],
  },
  {
    slug: "autocanhasrent",
    name: "Auto Canhas Rent",
    desc: "Website developed for a local rent a car company with the goal of giving a new look to the company and making the rent process easier for clients. The website is fully responsive and user friendly, all the design is made to orient the user into rent a car in a easy and well thought manner.",
    link: "https://www.autocanhasrentacar.com",
    thumb:"/img/canhas-thumb.png",
    mainImg: "/img/canhas-home.png",
    roleTags: "UI | WEBSITE",
    role: "In this project I was part of the design and user experience team we worked with the goal of making a professional website that can display all the available options to the user and with a friendly interface for rent one of the available cars.Posteriorly I builded all the interface into the final website using Webflow.",
    imgs:[
      "/img/canhas-img-1.png",
      "/img/canhas-img-2.png",
    ],
  },
  {
    slug:"archt",
    name: "Archt",
    link: "" ,
    thumb: "/img/arch-thumb.png",
    mainImg: "/img/arch.png",
    role: "UI",
    roleTags: "UI | UX",
    company:"/img/drawing.png",
    role: "Design of the layout.",
    imgs:[
      "/img/arch_home.png",
      "/img/arch_projects.png",
      "/img/arch_product.png",
    
    ],
    desc:
      "Fictional website design for a possible arquitecture or 3d modelling company.",
  },
{
      slug:"habitat",
      name: "Habitat Madeira",
      roleTags: "Website | UX",
      thumb: "/img/habitat-thumb.png",
      link: "https://www.habitatmadeira.com/",
      mainImg: "../img/w1.png",
      company:"/img/watching.jpg",
      role: "Design and website for a whale watching  company in Madeira Island.",
      imgs:[
        "/img/w1.png",
        "../img/w2.png",
        "/img/w3.png",
        "../img/w4.png",
      ],
      desc:
        "Design and development of the website using the platform webflow.",

    }
]

export default works;